<div class="mh-32 overflow-hidden">
  <div class="d-flex jc-fe mv-32" *ngIf="showExcelDownload">
    <button
      *ngIf="loadingExcel"
      class="btn ph-32 btn-run ml-24 d-flex color-login-text"
      type="button"
      (click)="downloadExcel()"
    >
      <mat-icon class="mr-8">cloud_download</mat-icon>
      Descargar Clientes
    </button>
    <button
      *ngIf="!loadingExcel && !(excelData?.length > 0) && excelData !== []"
      class="btn btn-primary ph-32 btn-pass"
      type="button"
      disabled
    >
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Cargando...
    </button>
  </div>
  <div class="content-filter jc-sb">
    <div class="dataTables_length">
      <label class="d-flex ai-center w-space color-login-text font-book fts-14"
        >Cantidad por página
        <select
          aria-controls="example"
          class="form-select form-select-sm ml-8"
          [(ngModel)]="pageSize"
          (ngModelChange)="refreshPagination()"
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="200">200</option>
        </select>
      </label>
    </div>
    <div id="example_filter" class="dataTables_filter">
      <label class="d-flex ai-center color-login-text font-book fts-14"
        >Buscar:
        <input
          type="search"
          class="form-control form-control-sm ml-8"
          [(ngModel)]="characterSearch"
          (ngModelChange)="searchList($event)"
          maxlength="50"
      /></label>
    </div>
  </div>
  <div class="mv-32 overflow-auto">
    <table class="table">
      <thead class="">
        <tr>
          <th scope="col ta-c" (sort)="onSort($event)">Código</th>
          <th scope="col ta-s" (sort)="onSort($event)">
            Razon Social
          </th>
          <th scope="col ta-c">Aliados Puntos</th>
          <th scope="col ta-c">Recoge</th>
          <th scope="col ta-c">Reporte de reconocimientos</th>
          <th scope="col ta-c">Avances</th>
          <th scope="col ta-c">Aliados Beneficios</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let country of listSpecialUserShow; let i = index">
          <td scope="row" class="ta-c">{{ country.code }}</td>
          <td class="ta-s">{{ country.name }}</td>
          <td class="ta-c">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="country.ally"
              (change)="onChangeCheckbox(country?.ally, 'ally', i, country)"
            />
          </td>
          <td class="ta-c">
            <div class="d-flex justify-content-center">
              <mat-slide-toggle
                #slide
                (change)="
                  onChange(
                    country.pickUp,
                    country.code,
                    slide,
                    country.pickUpStatus,
                    i
                  )
                "
                [checked]="country.pickUpStatus"
                >Activar
              </mat-slide-toggle>
            </div>
          </td>
          <td class="ta-c">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="country.benefit"
              (change)="onChangeCheckbox(country.benefit, 'benefit', i, country)"
            />
          </td>
          <td class="ta-c">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="country.advance"
              (change)="onChangeCheckbox(country.advance, 'advance', i, country)"
            />
          </td>
          <td class="ta-c">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="country.partner"
              (change)="onChangeCheckbox(country.partner, 'partner', i, country)"
            />
          </td>
        </tr>
        <ng-container *ngIf="loading">
          <tr *ngFor="let number of counter(pageSize)">
            <td scope="row" class="ta-c td-padding">
              <ngx-skeleton-loader count="1" appearance="line" class="mb-0"></ngx-skeleton-loader>
            </td>
            <td class="ta-c td-padding">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </td>
            <td class="ta-c td-padding">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </td>
            <td class="ta-c td-padding">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </td>
            <td class="ta-c td-padding">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </td>
            <td class="ta-c td-padding">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </td>
            <td class="ta-c td-padding">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div
      class="show-box-shadow pv-10 ph-16 ai-center ta-c jc-center mb-18 font-book"
      *ngIf="!loading && collectionSize === 0 && !errorListSpecialUser"
    >
      <span class="fts-12">No existe registros del cliente</span>
    </div>
    <div
      class="show-box-shadow pv-10 ph-16 ai-center ta-c d-flex jc-center mb-18 font-book color-secondary"
      *ngIf="!loading && errorListSpecialUser"
    >
      <div *ngIf="errorSpecialAttributes !== 404" class="ph-48 pv-16">
        <img src="assets/images/spot-server-fail.svg" alt="" height="45" />
        <br />
        <span class="fts-16 pt-16"><strong>¡Vaya! Algo salió mal</strong></span>
        <br />
        <span class="fts-12"
          >Lo sentímos, el servidor ha encontrado un error interno y no se encuentra disponible en este momento, por
          favor intenta más tarde.</span
        >
      </div>
      <div *ngIf="errorSpecialAttributes === 404" class="ph-48 pv-16">
        <img src="assets/images/spot-not-found.svg" alt="" height="45" />
        <br />
        <span class="fts-12 pt-16"
          >Lo sentimos, pero el cliente que busca no existe o no se puede encontrar, esto puede deberse a que se ha
          escrito incorrectamente o ha sido dada de baja.</span
        >
      </div>
    </div>
    <div
      class="content-count jc-sb ai-center pv-16"
      *ngIf="!errorListSpecialUser && !(!loading && collectionSize === 0 && !errorListSpecialUser)"
    >
      <div class="dataTables_length font-book">
        Total
        <span class="fontw-500">{{ collectionSize }}</span> registros
      </div>
      <div>
        <ngb-pagination
          [collectionSize]="collectionSize"
          [(page)]="page"
          [pageSize]="pageSize"
          [maxSize]="5"
          (pageChange)="refreshPagination()"
        >
          <ng-template ngbPaginationPrevious>Previous</ng-template>
          <ng-template ngbPaginationNext>Next</ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>
